export function setupMenuHoverEffect() {
  const menuContainer = document.querySelector('.inner-header-wrapper');
  const menuLinks = document.querySelectorAll('.nav-item.contain-mega-menu');
  const width = window.innerWidth;

  // Run this only on desktop
  if (width < 1199) {
    return; // stop the script
  }

  if (!menuContainer || menuLinks.length === 0) return;

  menuLinks.forEach(link => {
    // Hover effect (your existing code)
    // ⬇️ NEW CODE: find the mega menu content inside this nav item
    const megaContent = link.querySelector('.contain-mega-menu__content');

    link.addEventListener('mouseenter', () => {
      menuContainer.classList.add('header-radius');
      megaContent.style.opacity = '1';
      megaContent.style.visibility = 'visible';
      megaContent.style.transition = '.4s';
      megaContent.style.top = '77%';
    });

    link.addEventListener('mouseleave', () => {
      menuContainer.classList.remove('header-radius');
      megaContent.style.opacity = '0';
      megaContent.style.visibility = 'hidden';
      megaContent.style.transition = '0s';
      megaContent.style.top = '100%';
    });


    if (megaContent) {
      // Find all the clickable links inside it
      const innerLinks = megaContent.querySelectorAll('.contain-mega-menu__link');

      innerLinks.forEach(innerLink => {
        innerLink.addEventListener('click', e => {
          // Optional: prevent navigation for testing
          // e.preventDefault();

          // Hide the parent content
          megaContent.style.opacity = '0';
          megaContent.style.visibility = 'hidden';
          menuContainer.classList.remove('header-radius');
        });
      });
    }
  });
}
